export const STATUS_OPTIONS = ['To Do', 'In Progress', 'Done'];
